export const Outright = `
{{var esportsLogoURL = data.esportsLogoURL || '';}}
{{var ot = data.ot;}}
{{var options = data.options;}}
{{var leagues = data.a;}}

{{var spId = data.spId;}}
{{var sportIconClazz = 'sport-icon sports-fonticons icon-' + convertToSportIcon(spId);}}
{{var isEsport = spId == 12;}}
{{var participant_count=1, nowTime=moment(), leagueTime;}}
{{var expandLeagues = data.expandLeagues || [0];}}
{{? leagues && leagues.length > 0 }}
  {{~leagues :lg:lge_index}}
    {{var leagueId = lg.li; }}
    {{var leagueEventName = lg.levn || '';}}
    {{var teamNames = leagueEventName.split(' vs ');}}
    {{var teamAName = teamNames[0];}}
    {{var teamBName = teamNames[1];}}
    {{ leagueTime = moment(new DateTZ(lg.lt)).format(i18n("format:ddd, MMM. DD")).replaceAll("-", ""); }}
    {{var code = lg.gameCode;}}
    {{var isExpand = expandLeagues.includes(lge_index);}}
    <div class="league" id='lg{{=leagueId}}' index="{{=lge_index}}">
      <div class="league-title{{=isExpand ? ' expand' : ''}}">
        {{var leagueName = lg.ln;}}
        {{var type = lg.cg && lg.cg !== 'Futures' ? ': ' + lg.cg : '';}}
        <span id="league-name">
          {{? leagueName}}
            {{var teams = leagueEventName && lg.cg !== 'Futures' ? ': ' + leagueEventName : '';}}
            <span class="league-name">
              {{=leagueName || ''}} {{= type}} {{= teams}}
            </span>
          {{?}}
          <span class="expand-icon""></span>
        </span>
      </div>
      <div class="contestant-lines" id="tb{{=leagueId}}" index="{{=lge_index}}">
        {{~lg.se :ev:ev_index}}
          <div class="contestant-line">
            <div class="special-name">
              {{?ev.e && lg.cg == 'Futures'}}
                <span>{{=ev.e}}&nbsp;:&nbsp;</span>
              {{?}}
              <span>{{=ev.n}}</span>
              <span class='event-time'>
                {{=leagueTime}}
                <span class='hour'>{{=moment(new DateTZ(ev.d)).format(i18n("HH:mm"))}}</span>
              </span>
            </div>
            <div class="participants {{=ev.cg}}">
              {{var lines = ev.l;}}
              {{~lines :ctl:ctl_index}}
                {{var participant_count = participant_count + 1;}}
                {{var propsLabel = ev.bt === 'MULTI_WAY_HEAD_TO_HEAD' ? '' : ctl.h;}}
                <div id="{{=ctl.i}}" class='{{=participant_count%2==0?"even":""}} event-line participant'>
                  <div class="event-name">
                    {{? ctl.h > 0}}
                      <span>{{=ctl.n}}&nbsp;{{=propsLabel}}&nbsp;{{=i18n(ev.un ? ('&nbsp;' + ev.un) : '')}}</span>
                    {{??}}
                      <span>{{=ctl.n}}</span>
                    {{?}}
                  </div>
                  <div class="event-odds">
                    {{? ev.st != 'H' && ctl.p != 0}}
                      <a class="odds outright-odds {{=ctl.p < 0 ? 'neg' : ''}}"
                        data-oddsid="{{=ctl.l}}"
                        data-team-type="0"
                        data-odds="{{=ctl.p}}"
                        id='{{=ev.si}}|0|99|10|0|{{=ctl.h === null ? 0 : ctl.h}}|{{=ctl.i}}'
                        data-category="{{=ev.cg}}"
                        is-outright="1"
                      >
                        {{? ot=== OddsFormat.American}}
                          {{? ctl.p > 0}}
                            <span>+{{=ctl.p.toFixed(0)}}</span>
                          {{??}}
                            <span>{{=ctl.p.toFixed(0)}}</span>
                          {{?}}
                        {{??}}
                          {{? ot === OddsFormat.Indonesian}}
                            <span>{{=ctl.p.toFixed(2)}}</span>
                          {{??}}
                            <span>{{=ctl.p.toFixed(3)}}</span>
                          {{?}}
                        {{?}}
                      </a>
                    {{?}}
                  </div>
                </div>
                {{ participant_count = 1; }}
              {{~}}
              {{? lines.length %2 !== 0 }}
                <div class='participant'></div>
              {{?}}
            </div>
          </div>
        {{~}}
      </div>
    </div>
  {{~}} 
{{??}} 
  <div class="no-event">{{=i18n("errors",'No Events')}}</div>
{{?}}
`;


// WEBPACK FOOTER //
// ./src/app/components/CompactView/OddsPageComponent/Templates/Outright.js